var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOctagonShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.103 2H14.897C15.2911 1.99995 15.6814 2.07756 16.0455 2.22838C16.4096 2.3792 16.7404 2.60029 17.019 2.879L21.12 6.98C21.399 7.25867 21.6204 7.58961 21.7714 7.95389C21.9223 8.31818 22 8.70866 22 9.103V14.897C22 15.2911 21.9224 15.6814 21.7716 16.0455C21.6208 16.4096 21.3997 16.7404 21.121 17.019L17.02 21.12C16.7414 21.3987 16.4106 21.6198 16.0465 21.7706C15.6824 21.9214 15.2921 21.999 14.898 21.999H9.103C8.7089 21.999 8.31865 21.9214 7.95455 21.7706C7.59045 21.6198 7.25963 21.3987 6.981 21.12L2.88 17.02C2.60099 16.7413 2.37965 16.4104 2.22865 16.0461C2.07765 15.6818 1.99995 15.2913 2 14.897V9.103C1.99995 8.7089 2.07756 8.31865 2.22838 7.95455C2.3792 7.59045 2.60029 7.25963 2.879 6.981L6.98 2.88C7.25867 2.60099 7.58961 2.37965 7.95389 2.22865C8.31818 2.07765 8.70866 1.99995 9.103 2Z",
    fill: "#AD6643",
    stroke: "#AD6643",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonShape);
export default __webpack_public_path__ + "static/media/octagon-shape.8dab150f7497772d6fb9d3fc0d84a9b8.svg";
export { ForwardRef as ReactComponent };